import './unauthorized.styles.scss';
export const Unauthorized = ({ message }) => {
  return (
    <>
      <div id="unauthorizeContainer">
          <h1>Acceso Restringido</h1>
          <p>
            {message
              ? message
              : "Por favor, contacte al administrador."
            }
          </p>
      </div>
    </>
  );
}
